import React, { useState } from "react";
import PropTypes from "prop-types";
import SFSwitch from "../../../toggleSwitch";
import { SFStack } from "../../../grid";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const SwitchActionWrapper = styled(SFStack)(() => ({
  ".MuiTypography-root": {
    // Prevent the switch label from wrapping to a new line
    textWrap: "nowrap",
  },
}));

const SwitchAction = ({ actionDef }) => {
  // Use internal state only if not in controlled mode
  const [internalSwitchState, setInternalSwitchState] = useState(actionDef.switchProps?.initial === "on");

  // Check if component is in controlled mode
  const isControlled = actionDef.switchProps?.controlled === true;

  // For controlled mode, use the provided value, otherwise use internal state
  const switchOn = isControlled
    ? actionDef.switchProps?.value === true
    : internalSwitchState;

  const { onLabel } = actionDef.switchProps;
  const offLabel = actionDef.switchProps?.offLabel || onLabel;

  const toggleSwitch = () => {
    // Only update internal state if not controlled
    if (!isControlled) {
      setInternalSwitchState(prev => !prev);
    }
    // Always call onClick with the next state (opposite of current)
    actionDef.onClick(!switchOn);
  };

  return (
    <SwitchActionWrapper alignItems="center" justifyContent="center">
      <SFSwitch
        checked={switchOn}
        onChange={toggleSwitch}
        rightLabel={switchOn ? onLabel : offLabel}
        disabled={actionDef.disabled}
      />
    </SwitchActionWrapper>
  );
};

export default SwitchAction;

SwitchAction.propTypes = {
  actionDef: PropTypes.shape({
    // The name of the action
    name: PropTypes.string.isRequired,
    // The function to call when the switch is toggled on/off (receives the new state as a parameter)
    onClick: PropTypes.func.isRequired,
    // Props specific to the switch action
    switchProps: PropTypes.shape({
      // The label of the switch when it is on
      onLabel: PropTypes.string,
      // The label of the switch when it is off
      offLabel: PropTypes.string,
      // The initial state of the switch
      initial: PropTypes.oneOf(["on", "off"]),
      // Whether the switch is controlled from outside
      controlled: PropTypes.bool,
      // Current value of the switch (required when controlled is true)
      value: PropTypes.bool,
    }),
  }),
};
